module.exports = __webpack_public_path__ + "static/img/shezhi_yaoqing.b0417de2.png";